import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Box } from '../Box/index.js';

const statuses = {
  success: 'aloe500',
  warning: 'marigold500',
  alert: 'watermelon500',
  info: 'turquoise500',
  action: 'blue500',
  none: 'white'
};
/* ======================================= */
/**
 * Badges are used to highlight an item's status for quick recognition.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/badge#usage)
 * - [Props](https://blockparty.endpoint.com/components/badge#props)
 * <br />
 *
 */
const Badge = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    status = 'alert',
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: forwardedRef,
    backgroundColor: statuses[status]
    // matches figma value
    ,
    borderRadius: "12px",
    color: status === 'none' ? 'text' : 'white',
    fontSize: "fontSize10",
    minHeight: 16,
    minWidth: 16,
    px: "space20",
    textAlign: "center"
  }, rest), children);
});

export { Badge };
